<script>
  import { onMount, onDestroy } from 'svelte';
  import ProductItem from './ProductItem.svelte';
// Prop data
  export let products, maxCol=4;
  const col = n => maxCol === n;
</script>

{#if (products || []).length > 0}
  {#each (products || []) as product}
    <ProductItem {product}/>
  {/each}
{:else}
  <h1>...</h1>
{/if}
